const API_BASE = 'https://sci2512be.siparisci.com/api/v2512';
const MAIN_DOMAIN = 'siparisci.com';
const BROCHURE_PATHS = ['/', '/features', '/pricing', '/about'];

const BROCHURE_TITLES = {
  '/': 'Evinizin En Yakınındaki - Siparisci.com',
  '/features': 'Özellikler - Siparisci.com',
  '/pricing': 'Fiyatlandırma - Siparisci.com',
  '/about': 'Hakkımızda - Siparisci.com',
};

const BROCHURE_FILES = {
  '/': '/brochure/landing.html',
  '/features': '/brochure/features.html',
  '/pricing': '/brochure/pricing.html',
  '/about': '/brochure/about.html',
};

function detectMode(hostname, pathname) {
  if (pathname.startsWith('/admin') || pathname.startsWith('/staff')) return 'admin';

  const normalized = hostname.replace(/^www\./, '');

  if (normalized === 'localhost' || normalized === '127.0.0.1') return 'platform';

  if (normalized !== MAIN_DOMAIN && normalized.endsWith(`.${MAIN_DOMAIN}`)) return 'tenant';

  if (!normalized.endsWith(MAIN_DOMAIN) && !normalized.endsWith(`.${MAIN_DOMAIN}`)) return 'tenant';

  return 'platform';
}

function isBrochurePath(pathname) {
  return BROCHURE_PATHS.includes(pathname);
}

async function query(request) {
  const response = await fetch(`${API_BASE}/query`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
}

async function loadShopConfig() {
  const hostname = window.location.hostname;
  const normalizedDomain = hostname.replace(/^www\./, '');
  const pathname = window.location.pathname;

  let shop;

  try {
    const slugMatch = pathname.match(/^\/shop\/([^\/]+)/);
    if (slugMatch && slugMatch[1]) {
      const slug = slugMatch[1];
      const response = await query({
        operation: 'list',
        table: 'shops',
        filter: {
          is_active: { eq: 1 },
          slug: { eq: slug },
        },
      });

      if (response.success && response.data?.[0]) {
        shop = response.data[0];
        console.log('Loaded shop by slug:', slug);
      }
    }
  } catch (error) {
    console.error('Failed to load shop by slug:', error);
  }

  if (!shop) {
    try {
      const response = await query({
        operation: 'list',
        table: 'shops',
        filter: {
          is_active: { eq: 1 },
          domains: { like: `%${normalizedDomain}%` },
        },
      });

      if (response.success && response.data?.[0]) {
        shop = response.data.find(s =>
          s.domains?.split(',').some(d => d.trim() === normalizedDomain)
        );
        if (shop) console.log('Loaded shop by domain:', normalizedDomain);
      }
    } catch (error) {
      console.error('Failed to load shop by domain:', error);
    }
  }

  if (!shop) {
    try {
      const response = await query({
        operation: 'get',
        table: 'shops',
        id: 1,
      });

      if (response.success && response.data?.[0]) {
        shop = response.data[0];
        console.log('Loaded default shop (id:1)');
      }
    } catch (error) {
      console.error('Failed to load default shop:', error);
    }
  }

  if (!shop) return null;

  try {
    const response = await query({
      operation: 'list',
      table: 'shop_themes',
      filter: {
        sid: { eq: shop.id },
      },
      limit: 1,
    });

    if (response.success && response.data?.[0]) {
      shop.theme = response.data[0];
    }
  } catch (error) {
    console.error('Failed to load shop theme:', error);
  }

  return shop;
}

async function loadBrochureCSS() {
  if (!document.querySelector('link[href="/brochure.css"]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/brochure.css';
    document.head.appendChild(link);
  }
}

async function unloadBrochureCSS() {
  const link = document.querySelector('link[href="/brochure.css"]');
  if (link) {
    link.remove();
  }
}

async function renderBrochurePage(pathname) {
  const file = BROCHURE_FILES[pathname];
  if (!file) return false;

  await loadBrochureCSS();

  try {
    const response = await fetch(file);
    if (!response.ok) return false;

    let html = await response.text();
    html = html.replace(/\{\{YEAR\}\}/g, new Date().getFullYear());

    document.title = BROCHURE_TITLES[pathname] || 'Siparisci.com';
    document.getElementById('root').innerHTML = html;
    return true;
  } catch (error) {
    console.error('Failed to load brochure page:', error);
    return false;
  }
}

async function renderBlogPage(shop, blogPost) {
  const root = document.getElementById('root');

  document.title = `${blogPost.meta_title || blogPost.title} - ${shop.name}`;

  if (blogPost.meta_description) {
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = blogPost.meta_description;
  }

  if (blogPost.meta_keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = blogPost.meta_keywords;
  }

  root.innerHTML = blogPost.content;
}

async function loadBlogPost(blogPostId) {
  try {
    const response = await query({
      operation: 'list',
      table: 'blog_posts',
      filter: {
        id: { eq: blogPostId },
        is_deleted: { eq: 0 },
      },
      limit: 1,
    });

    if (response.success && response.data?.[0]) {
      return response.data[0];
    }
  } catch (error) {
    console.error('Failed to load blog post:', error);
  }

  return null;
}

let currentSystem = 'none';
let shopConfig = null;
let appMode = 'platform';

async function init() {
  window.__shopLoaderActive = true;

  const hostname = window.location.hostname;
  const pathname = window.location.pathname;
  appMode = detectMode(hostname, pathname);

  if (appMode === 'tenant') {
    shopConfig = await loadShopConfig();
  }

  await handleRoute();

  window.addEventListener('popstate', handleRoute);
}

async function handleRoute() {
  const pathname = window.location.pathname;

  if (appMode === 'platform') {
    if (isBrochurePath(pathname)) {
      if (currentSystem === 'react') {
        const { unmountReactApp } = await import('./main.tsx');
        unmountReactApp();
      }
      const rendered = await renderBrochurePage(pathname);
      if (rendered) {
        currentSystem = 'brochure';
        return;
      }
    }
  }

  if (appMode === 'tenant') {
    const isRootPath = pathname === '/';
    const shouldShowBlog = isRootPath && shopConfig && shopConfig.theme && shopConfig.theme.frontpage_type === 'blog_post';

    if (shouldShowBlog) {
      if (currentSystem === 'react') {
        const { unmountReactApp } = await import('./main.tsx');
        unmountReactApp();
      }

      const blogPostId = shopConfig.theme.frontpage_blog_post_id;
      if (blogPostId) {
        const blogPost = await loadBlogPost(blogPostId);
        if (blogPost) {
          await renderBlogPage(shopConfig, blogPost);
          currentSystem = 'blog';
          return;
        }
      }
    }
  }

  if (currentSystem !== 'react') {
    await unloadBrochureCSS();
    const { mountReactApp } = await import('./main.tsx');
    mountReactApp();
    currentSystem = 'react';
  }
}

init();
